var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7516 9.15004C21.2616 8.37004 20.7016 7.67004 20.1216 7.04004L16.3516 10.81C16.4716 11.18 16.5416 11.58 16.5416 12C16.5416 14.24 14.7316 16.04 12.5016 16.04C12.0816 16.04 11.6816 15.97 11.3116 15.85L7.85156 19.31C9.31156 20.13 10.8916 20.56 12.5016 20.56C14.2816 20.56 16.0116 20.04 17.5916 19.07C19.1716 18.09 20.5916 16.66 21.7516 14.84C22.7516 13.28 22.7516 10.72 21.7516 9.15004Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5206 9.97989L10.4806 14.0199C9.97062 13.4999 9.64062 12.7799 9.64062 11.9999C9.64062 10.4299 10.9206 9.13989 12.5006 9.13989C13.2806 9.13989 14.0006 9.46989 14.5206 9.97989Z",
    fill: "#1177BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5.74993L15.36 9.13993C14.63 8.39993 13.62 7.95993 12.5 7.95993C10.26 7.95993 8.46 9.76993 8.46 11.9999C8.46 13.1199 8.91 14.1299 9.64 14.8599L6.26 18.2499H6.25C5.14 17.3499 4.12 16.1999 3.25 14.8399C2.25 13.2699 2.25 10.7199 3.25 9.14993C4.41 7.32993 5.83 5.89993 7.41 4.91993C8.99 3.95993 10.72 3.42993 12.5 3.42993C14.73 3.42993 16.89 4.24993 18.75 5.74993Z",
    fill: "#84DCC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3581 12.0001C15.3581 13.5701 14.0781 14.8601 12.4981 14.8601C12.4381 14.8601 12.3881 14.8601 12.3281 14.8401L15.3381 11.8301C15.3581 11.8901 15.3581 11.9401 15.3581 12.0001Z",
    fill: "#1177BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2728 2.22988C21.9728 1.92988 21.4828 1.92988 21.1828 2.22988L2.73281 20.6899C2.43281 20.9899 2.43281 21.4799 2.73281 21.7799C2.88281 21.9199 3.07281 21.9999 3.27281 21.9999C3.47281 21.9999 3.66281 21.9199 3.81281 21.7699L22.2728 3.30988C22.5828 3.00988 22.5828 2.52988 22.2728 2.22988Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.fd37892614a7b7f24edeef7f44346ac0.svg";
export { ForwardRef as ReactComponent };